import React from "react";

import { connect, useSelector } from "react-redux";

import "./ProfileNavigation.scss";
import { signOut } from "../../store/actions/AuthActions";
import UserLinks from "./UserLinks";
import AdminLinks from "./AdminLinks";
import { isLoaded, isEmpty } from "react-redux-firebase";

const ProfileNavigation = ({ signOut }) => {
  const profile = useSelector(({ firebase }) => firebase.profile);
  const profileExists = isLoaded(profile) && !isEmpty(profile);
  const profileIsAdmin = profileExists && profile.isAdmin;
  if (!profileExists) return <div></div>;

  return (
    <div className="sidebar bg-white shadow-sm py-8">
      {profileIsAdmin ? (
        <AdminLinks signOut={signOut}></AdminLinks>
      ) : (
        <UserLinks signOut={signOut}></UserLinks>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
  };
};

export default connect(null, mapDispatchToProps)(ProfileNavigation);
